module.exports = __webpack_public_path__ + "fonts/LG_Smart_UI-Bold.92c15de.woff";